import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Renderer2,
  inject,
} from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';
import { JoditAngularComponent } from 'jodit-angular';
import { asyncScheduler, Subscription } from 'rxjs';
import { get } from 'lodash';

@Component({
  selector: 'app-formly-field-richtext',
  template: `
    <jodit-editor
      class="outline-none"
      #editor
      [config]="config"
      (onChange)="change()"
      appManualFocus
      [field]="field"
    ></jodit-editor>
  `,
  styles: [
    `
      .outline-none {
        outline: none !important;
      }
    `,
  ],
})
export class FormlyFieldRichTextComponent
  extends FieldType
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('editor', { static: true }) editor: JoditAngularComponent;
  renderer = inject(Renderer2);
  config: {};
  isFocused = false;

  subscription = new Subscription();

  change() {
    this.formControl.setValue(this.editor.value);
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
  }

  ngOnInit() {
    this.config = this.getJoditConfig(this.to.readonly);

    this.subscription.add(
      this.formControl.valueChanges.subscribe((value) => {
        if (value === undefined || value === null) {
          this.editor.value = null;
          this.formControl.markAsUntouched();
          this.formControl.markAsPristine();
        }
        this.editor.value = value;
      })
    );

    this.subscription.add(
      this.formControl.root.valueChanges.subscribe((value) => {
        // weird hack to set the readonly state
        asyncScheduler.schedule(() => {
          this.toggleReadOnlyState(
            get(this, 'field.templateOptions.readonly', false)
          );
        });
      })
    );
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.editor?.editor?.editor?.setAttribute('tabindex', '0');
  }

  private toggleReadOnlyState(isReadonly: boolean) {
    this.config = this.getJoditConfig(isReadonly);
  }

  private getJoditConfig(isReadonly: boolean = false): {} {
    return {
      buttons: 'bold,italic,underline,|,paragraph,ul,ol,outdent,indent,|,align',
      showPlaceholder: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      showCharsCounter: false,
      minHeight: 150,
      toolbarAdaptive: false,
      readonly: isReadonly,
      allowTabNavigation: true,
      tabIndex: 0,
    };
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
